import { useViewport } from './useViewport';

/**
 * Backward-compatible alias around `useViewport`. New code should call
 * `useViewport` directly to access richer breakpoint flags.
 *
 * `isMobile` here matches CSS `down('md')` (≤ 959.95 px) so it stays in sync
 * with the breakpoint helpers used in styled components.
 */
export const useIsMobile = (): { isMobile: boolean; isTouchDevice: boolean } => {
	const { isMd, isTouchDevice } = useViewport();
	return { isMobile: isMd, isTouchDevice };
};
